<template>
    <v-layout class="flex-column ">
        <v-row class="align-center justify-space-between px-3">
            <v-col cols="12">
                <v-item-group mandatory @change="changeTab">
                    <v-container class="ma-auto pa-0 w-100">
                        <v-row class="justify-center">
                            <v-col
                                    v-for="(n, index) in tabs"
                                    :key="index"
                                    cols="12"
                                    lg="2"
                                    md="2"
                                    sm="4"
                                    class="pa-0"
                            >
                                <v-item v-slot="{ active, toggle }">
                                    <v-card
                                            :color="active ? 'primary' : '#f4f6f8'"
                                            class="d-flex align-center justify-center"
                                            height="42"
                                            dark
                                            flat
                                            outlined
                                            @click="toggle"
                                            style="border-radius: 0"
                                    >
                                        <v-scroll-y-transition>
                                            <div v-if="active" >{{n.name}}</div>
                                            <div v-if="!active" style="color: #411F90">{{n.name}}</div>
                                        </v-scroll-y-transition>
                                    </v-card>
                                </v-item>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-item-group>
            </v-col>
        </v-row>
        <AllVendors v-if="currentTab === 0"/>
        <Domains v-if="currentTab === 1"/>
        <UnmappedDomains v-if="currentTab === 2"/>
    </v-layout>
</template>

<script>
    import AllVendors from "./AllVendors";
    import Domains from "./Domains";
    import UnmappedDomains from "./UnmappedDomains";
    export default {
        name: "VendorsManagementDashboard",
        components: { AllVendors, Domains, UnmappedDomains},
        data: () => ({
            openOnClick: false,
            currentTab: 0,
            tabs: [{id: 0, name: 'VENDORS'}, {id: 1, name: 'DOMAINS'}, {id: 2, name: 'UNMAPPED DOMAINS'}],
        }),
        methods: {
            changeTab(e){
                this.currentTab = e;
            },
        },
    }
</script>
